var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 33,
    viewBox: "0 0 127 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 33,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_209_478",
    transform: "scale(0.00787402 0.030303)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_209_478",
    width: 127,
    height: 33,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH8AAAAhCAYAAADwOXSUAAAACXBIWXMAAAsSAAALEgHS3X78AAACw0lEQVR4nGL8//8/wygYgYCBgQEAAAD//2IZjXcCIIcRNXdM+c84CF1JOmBgYAAAAAD//0KNfHSP0grgCkB62E/PyCM24ZDrb5h52PQj24XNHQwMDAAAAAD//xqYnA9yzEDlIGx2kxL4hNQOlZKBgYEBAAAA//9iGgRuGAUDARgYGAAAAAD//xqZkU+v6m0wAwYGBgAAAAD//0It9mlZZBET4LSyf6hFNrZwoLYfGBgYAAAAAP//Gm3tg8AwasETDRgYGAAAAAD//xqNfGIAcq4bKgmFUEnBwMAAAAAA//8amK7eYAf4wmEoJgRsgIGBAQAAAP//Gs356ICcbh+xiWAwJRwGBgYAAAAA//8a7eohA3JLvqFYYjIwMAAAAAD//yKc80dKYwhXBFIyIDSQAN8IHwgwMDAAAAAA//8aLfZxAVyJHteQKjVHLemRwBgYGAAAAAD//xqNfBAgJ7BBEU2qvsFUijIwMAAAAAD//yIc+bRKhYO5OhkJVR0DAwMAAAD//xpt8A0GMBCJjYGBAQAAAP//whzeHe3rDwygdwJgYGAAAAAA///CzPkjdKhzxAEGBgYAAAAA///CXueTM2hBir5RMPBhycDAAAAAAP//Gm3tYwMDudiEHECOWxkYGAAAAAD//xpt8JELhnrbiIGBAQAAAP//Go18ECB1/pzQmrmhABgYGAAAAAD//6LurB4lgx6DMScN554PAwMDAAAA//8azfkwQEnOHYoNXQYGBgAAAAD//xpt8CEDfEuhCemhNqB1qcPAwAAAAAD//xqNfGyAUCIYDl1aBgYGAAAAAP//ot8CTkJgMAbocB63YGBgAAAAAP//Gq3zBwugd0JjYGAAAAAA//8a3ag5UgEDAwMAAAD//xrN+SMVMDAwAAAAAP//Go38kQoYGBgAAAAA//8ajfyRChgYGAAAAAD//wMArtyZibX3LeoAAAAASUVORK5CYIL/"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleLogo);
export default __webpack_public_path__ + "static/media/titleLogo.bfc1d7bc9a784b5252ce25178d65cb00.svg";
export { ForwardRef as ReactComponent };